export type Service = 'FCL' | 'LCL' | 'Air' | 'Road';
export const SERVICES: Service[] = ['FCL', 'LCL', 'Air', 'Road'];
export const SERVICE_NAME: Record<Service, string> = {
  FCL: 'Full Container Load',
  LCL: 'Less than Container Load',
  Air: 'Air Freight',
  Road: 'Road Transport',
};
